import { render, staticRenderFns } from "./overviewMatchResult.vue?vue&type=template&id=5213777b&scoped=true&"
import script from "./overviewMatchResult.vue?vue&type=script&lang=ts&"
export * from "./overviewMatchResult.vue?vue&type=script&lang=ts&"
import style0 from "./overviewMatchResult.vue?vue&type=style&index=0&id=5213777b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5213777b",
  null
  
)

export default component.exports